import { render, staticRenderFns } from "./EditBooleanColumn.vue?vue&type=template&id=04f73b0f&"
import script from "./EditBooleanColumn.vue?vue&type=script&lang=js&"
export * from "./EditBooleanColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports